class BuyNowButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.ug-buyNow-bth');
    this.init();
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this));
    }
  }

  getProductData() {
    const productForm = this.closest('product-form');
    const variantInput =
      productForm?.querySelector('input[name="id"]') ||
      document.querySelector('input.product-variant-id');
    const quantityInput = productForm?.querySelector('input[name="quantity"]');

    const variantId =
      variantInput?.value ||
      this.button?.getAttribute('data-variant-id') ||
      this.getAttribute('data-variant-id');

    const quantity = quantityInput
      ? Math.max(1, parseInt(quantityInput.value || 1, 10) || 1)
      : 1;

    return {
      variantId,
      quantity,
      productHandle:
        this.button?.getAttribute('data-product-handle') ||
        this.getAttribute('data-product-handle'),
      productId:
        this.button?.getAttribute('data-product-id') ||
        this.getAttribute('data-product-id'),
    };
  }


  setLoadingState(button, isLoading) {
    const spinner = button.querySelector('.loading__spinner');
    const buttonText = button.querySelector('.button-text');

    if (isLoading) {
      button.classList.add('loading');
      button.setAttribute('aria-disabled', true);
      spinner?.classList.remove('hidden');
      buttonText?.classList.add('hidden');
    } else {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
      buttonText?.classList.remove('hidden');
    }
  }

  async clearCart() {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to clear cart');
    }

    return response;
  }

  async addToCart(variantId, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }

    return response;
  }

  async applyGloodUpsell(variantId) {
    if (!window.Glood?.upsell) return;

    window.__gloodSuppressDrawerOpen = true;
    try {
      await Glood.upsell.commitPickSelections({
        triggerVariantId: variantId,
      });
      await Glood.upsell.addQualifyingFreeGifts();
    } finally {
      window.__gloodSuppressDrawerOpen = false;
    }
  }

  async processCheckout(button, variantId, quantity = 1) {
    try {
      this.setLoadingState(button, true);

      await this.clearCart();
      await this.addToCart(variantId, quantity);
      await this.applyGloodUpsell(variantId);
      
      this.redirectToCheckout();

    } catch (error) {
      console.error('Checkout error:', error);
      this.handleError('There was an error processing your request. Please try again.');
    } finally {
      this.setLoadingState(button, false);
    }
  }

  async handleClick(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const productData = this.getProductData();
    
    // console.log('Checkout attempt with:', productData);

    const checkoutVariantId = productData.variantId;

    if (checkoutVariantId) {
      await this.processCheckout(button, checkoutVariantId, productData.quantity);
    } else if (productData.productHandle) {
      this.redirectToProduct(productData.productHandle);
    } else {
      this.handleError("Sorry, we couldn't find the product information. Please try another product.");
    }
  }

  redirectToCheckout() {
    window.location.href = '/checkout';
  }

  redirectToProduct(productHandle) {
    window.location.href = '/products/' + productHandle;
  }

  handleError(message) {
    console.error(message);
    alert(message);
  }

}

customElements.define('buy-now-button', BuyNowButton);

// 引用
{/* <buy-now-button>
  <input class="quantity__input" type="number" value="1" min="1">
  <button class="buy_now" data-variant-id="123" data-quantity-control>
    <span class="button-text">Buy Now</span>
  </button>
</buy-now-button> */}